export default {
  header: 'Method',
  groupKey: 'method',
  filters: [
    { text: 'Casting', id: 'casting' },
    { text: 'Centrifugal Casting', id: 'centrifugalCasting' },
    { text: 'Die Casting', id: 'dieCasting' },
    { text: 'Investment Casting', id: 'investmentCasting' },
    { text: 'Permanent Mold Casting', id: 'permanentMoldCasting' },
    { text: 'Plaster Casting', id: 'plasterCasting' },
    { text: 'Sand Casting', id: 'sandCasting' },
    { text: 'Semi Permanent Mold Casting', id: 'semiPermanentMoldCasting' },
    { text: 'Unspecified', id: 'unspecified' },
    { text: 'Forging', id: 'forging' },
    { text: 'Cold Forging', id: 'coldForging' },
    { text: 'Upset Forging', id: 'upsetForging' },
    { text: 'Closed Die Forging', id: 'closedDieForging' },
    { text: 'Open Die/Hand Forging', id: 'openDieHandForging' },
    { text: 'Rolled Ring', id: 'rolledRing' },
    { text: 'Other Methods As Specified', id: 'otherMethodsAsSpecified' }
  ],
};


// WEBPACK FOOTER //
// ./src/config/searchFilters/methodFilters.js